import { render, staticRenderFns } from "./TabPartner.vue?vue&type=template&id=a85c4e60&scoped=true&"
import script from "./TabPartner.vue?vue&type=script&lang=js&"
export * from "./TabPartner.vue?vue&type=script&lang=js&"
import style0 from "./TabPartner.vue?vue&type=style&index=0&id=a85c4e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85c4e60",
  null
  
)

export default component.exports